const initialState = {
  cities: [],
  banks: [],
  bankLabels: [],
  items: [],
  variants: [],
  dealers: [],
  salesPersons: [],
  corporateClients: [],
  source: [],
  make: [],
  model: [],
  category: [],
  parts_variant: [],
  vehiclesWithMake: [],
  allVehcilesFlat: [],
  parts_color: [],
  vendors: [],
  tax: [],
  discount: [],
  transporter: [],
  departments: [],
  toggle_header: false,
  user: JSON.parse(localStorage.getItem("permissions")) || {},
  permission: JSON.parse(localStorage.getItem("permissionsMap")) || {},
  layoutstyledata: localStorage.getItem("layoutStyling"),
};

export default initialState;
